"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var commerceinteraction_1 = require("./commerceinteraction");
var formInteraction_1 = require("./formInteraction");
var notificationHander_1 = require("./notificationHander");
var pageload_1 = require("./pageload");
var screenload_1 = require("./screenload");
var searchinteraction_1 = require("./searchinteraction");
var paymentStatusReceiptHandler_1 = require("./paymentStatusReceiptHandler");
var linkInteraction_1 = require("./linkInteraction");
var popupLoadHandler_1 = require("./popupLoadHandler");
var popupClickHandler_1 = require("./popupClickHandler");
var abTestHandler_1 = require("./abTestHandler");
var bannerHandler_1 = require("./bannerHandler");
var downloadHandler_1 = require("./downloadHandler");
var videoHandler_1 = require("./videoHandler");
var audioHandler_1 = require("./audioHandler");
var socialInteractionHandler_1 = require("./socialInteractionHandler");
var certificationClickHandler_1 = require("./certificationClickHandler");
var productViewLoadHandler_1 = require("./productViewLoadHandler");
var contentViewLoadHandler_1 = require("./contentViewLoadHandler");
var conferenceViewLoadHandler_1 = require("./conferenceViewLoadHandler");
var language_1 = require("./language");
var buttonInteraction_1 = require("./buttonInteraction");
var agreements_1 = require("./agreements");
var modalLoadHandler_1 = require("./modalLoadHandler");
var taskHandler_1 = require("./taskHandler");
exports.default = [
    agreements_1.default,
    abTestHandler_1.default,
    audioHandler_1.default,
    bannerHandler_1.default,
    certificationClickHandler_1.default,
    commerceinteraction_1.default,
    conferenceViewLoadHandler_1.default,
    contentViewLoadHandler_1.default,
    downloadHandler_1.default,
    formInteraction_1.default,
    language_1.default,
    linkInteraction_1.default,
    buttonInteraction_1.default,
    modalLoadHandler_1.default,
    notificationHander_1.default,
    pageload_1.default,
    paymentStatusReceiptHandler_1.default,
    popupClickHandler_1.default,
    popupLoadHandler_1.default,
    productViewLoadHandler_1.default,
    screenload_1.default,
    searchinteraction_1.default,
    socialInteractionHandler_1.default,
    taskHandler_1.default,
    videoHandler_1.default,
];
